import React from "react";
import "./Login.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notifications } from "../../Helpers/Notifications";
import Api from "../../Common/api.jsx";

import { Navigate } from "react-router-dom";
import MetaMaskService from "../../Common/metamaskService.jsx";

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      redirect:'/'
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("click", () => {
      console.log("in1");
      document.getElementsByClassName("search-autocomplete")[0].style.display =
        "none";
    });
  }

  async connect() {
    let account = await new MetaMaskService().connect();
    if (!account) return;
    localStorage.setItem("accountId", account);

    try {
      //check if the account/user is present in DB. If not then insert a new user
      var user = {
        email: "",
        user_name: "",
        profile_pic: "",
        twitter_profile: "",
        banner_pic: "",
        phone_num: "",
        account: account.toLowerCase(),
      };

      await new Api().post("user_details/", user);

      await new Api()
        .get("get_user/?account=" + account)
        .then((response) => {
          notifications.success("Logged in successfully");
          if (response.data.profile_picture)
            localStorage.setItem(
              "profilePicture",
              response.data.profile_picture
            );
            if(localStorage.getItem("cartUrl")){
              this.setState({ redirect: localStorage.getItem("cartUrl") });
            }
            this.setState({ isLoggedIn: true });
        })
        .catch((err) => console.log(err));
      const timer = setTimeout(() => {
        //this.setState({ isLoggedIn: true });
      }, 1000);
    } catch (err) {
      notifications.error("Error occurred while saving user");
    }
  }

  render = () => {
    return (
      <>
        {this.state.isLoggedIn ? <Navigate to={this.state.redirect} replace={true} /> : <></>}
        <Header />
        <ToastContainer pauseOnFocusLoss draggable pauseOnHover />
        <section className="sign-up">
          <div className="exploreCollections">
            <div className="container">
              <div className="section-title">
                <h2>Connect to Wallet</h2>
              </div>
              <div className="sign-up__form">
                <ul className="connect-wallet-popup__list">
                  <li>
                    <div className="aside">
                      <a onClick={() => this.connect()}>
                        <i>
                          {" "}
                          <img
                            src="../images/svg/meta-mask.svg"
                            alt="MetaMask"
                          />{" "}
                        </i>{" "}
                        <span>MetaMask</span>
                      </a>{" "}
                      <a href="/" className="id-tag">
                        Most Popular
                      </a>
                    </div> 
                  </li>
                  <li className="disabled">
                  <div className="aside">
                    <a href="/">
                      <i>
                        {" "}
                        <img
                          src="../images/svg/coinbase.svg"
                          alt="Coinbase"
                        />{" "}
                      </i>{" "}
                      <span>Coinbase</span>
                    </a>
                  </div>
                  </li>
                  <li className="disabled">
                    <div className="aside">
                      <a href="/">
                        <i>
                          {" "}
                          <img
                            src="../images/svg/fortmatic.svg"
                            alt="Fortmatic"
                          />{" "}
                        </i>{" "}
                        <span>Fortmatic</span>
                      </a>
                    </div>
                  </li>
                </ul>
                {/* <div className="form-group">
                <label>Email Id</label>
                <input type="text" className="form-control" placeholder="Enter your Email id"/> 
              </div>
              <div className="form-group">
                <label>Password</label>
                <div className="form-control__wrapp"> 
                  <input type="text" className="form-control" placeholder="Enter your Password" />
                </div> 
              </div> */}

                {/* <div className="form-group__btn">
                <a href="/" className="button">
                  Log In
                </a>
              </div> */}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  };
}
